import RestroItems from "./Items";

const RestroCategory = ({ category, items, isOpen, onToggle }) => {
    return (
        <div className="border-b border-gray-100 last:border-none">
            <button
                className="w-full flex justify-between items-center py-4 text-left focus:outline-none group"
                onClick={onToggle}
            >
                <span className="font-bold text-gray-800 group-hover:text-orange-500 transition-colors">
                    {category} <span className="text-gray-400 font-semibold text-sm">({items.length})</span>
                </span>
                <span
                    className={`text-gray-400 text-lg transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                >
                    ▾
                </span>
            </button>
            {isOpen && (
                <div className="pb-3">
                    <RestroItems menuInfo={items} />
                </div>
            )}
        </div>
    );
};

export default RestroCategory;
